const ROLE_ALIASES = {
  shopper: "shopper",
  customer: "shopper",
  patient: "shopper",
  vendor: "vendor",
  partner: "vendor",
};

export const normalizeRole = (role) => {
  const key = String(role || "").trim().toLowerCase();
  return ROLE_ALIASES[key] || key || "shopper";
};

export const normalizeRoles = (roles) => {
  if (!Array.isArray(roles)) return [];
  return roles.map(normalizeRole).filter(Boolean);
};

export const isRoleAllowed = (currentRole, allowedRoles) => {
  const required = normalizeRoles(allowedRoles);
  if (required.length === 0) return true;
  return required.includes(normalizeRole(currentRole));
};

